import React from "react";
import tw from "twin.macro";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/TwoColumnWithVideo.js";
import Footer from "components/footers/MiniCenteredFooter.js";
import '../../src/styles.css';
import illustration from '../images/undraw_youtube-tutorial_xgp1.svg';
import VideoPlayer from './VideoPlayer.js'

const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col lg:flex-row max-w-screen-xl mx-auto py-20 md:py-24`;
const LeftColumn = tw.div`lg:w-8/12`;
const RightColumn = tw.div`lg:w-4/12 pl-6 mt-12 lg:mt-0`;

export default function SmartViewMDPage() {
  const HighlightedText = tw.span`bg-primary-500 text-gray-100 px-4 transform -skew-x-12 inline-block`;
  const imageCss = tw`rounded-4xl shadow-lg border-none`;


  return (
    <AnimationRevealPage>
      <Hero
        heading={<><HighlightedText>Digital Health Tools & Resources</HighlightedText></>}
        description="Access our growing library of secure training materials, featuring video walkthroughs and expert instructions for our suite of healthcare SaaS tools and connected health devices. Built for ease of use in fast-paced clinical environments."
        imageSrc= {illustration}
        imageCss={imageCss}
        primaryButtonText="Explore Videos"
        watchVideoButtonText="What is SmartViewMD?"
      />
      <section id = "blog">
      <Container>
        <TwoColumn>
          <LeftColumn>
          <VideoPlayer/>
          <Section id="SVMD" title="SmartViewMD 2 Camera Capture Feature" date="July 7, 2025">
              <YouTubeEmbed src="https://www.dropbox.com/scl/fi/qje97odg1y581wqq2xq1r/SmartViewMD-Camera-Reading.mp4?rlkey=c8rp0sl86px5iqkxjawai64nv&st=ya56o7x0&raw=1" />
              <p>With the SmartViewMD app, you can now monitor your blood pressure and other vitals using just your phone’s camera—no Bluetooth devices required. Simply follow the on-screen instructions to scan medical device, and your vitals will be securely recorded and synced with your SmartViewMD profile.

This seamless, bluetooth-free integration makes it easier than ever for patients and healthcare providers to track important health data over time, supporting better remote monitoring and care planning.</p>
            </Section>
            <Section id="BP" title="SmartViewMD.com Bluetooth Blood Pressure Monitor" date="January 1, 2014">
              <YouTubeEmbed src="https://player.vimeo.com/video/541602253" />
              <p>With the SmartView MD app, you can monitor your blood pressure at home using a Bluetooth-enabled blood pressure monitor. Simply pair your device following the instructions, and readings will automatically sync with your SmartViewMD profile.</p>
              <p>This seamless integration helps patients and healthcare providers track vital health data over time, allowing for better remote monitoring and care planning.</p>
            </Section>
            <Section id="ANDROID" title="Instructions to [Pair] & [Read] Bluetooth Blood Pressure Monitor with SmartViewMD [ANDROID]" date="January 1, 2014">
              <YouTubeEmbed src="https://www.youtube.com/embed/hz7hS8uQDvc" />
              <YouTubeEmbed src="https://www.youtube.com/embed/g7koYRd2vdA" />
              <p>Android users should ensure Bluetooth and location services are turned on. After downloading the SmartViewMD app, follow the in-app prompts to pair your monitor. Reading results will be displayed and saved in your account dashboard.</p>
            </Section>
            <Section id="iOS" title="Instructions to [Pair] & [Read] Bluetooth Blood Pressure Monitor with SmartViewMD [iOS]" date="January 1, 2014">
              <YouTubeEmbed src="https://www.youtube.com/embed/fFsBMZOyJ40" />
              <YouTubeEmbed src="https://www.youtube.com/embed/wjxuCDwPFvw" />
              <p>On iOS devices, pairing is slightly different. Be sure to enable Bluetooth access for the app in iPhone settings. The SmartViewMD app will walk you through the setup process. Confirm successful pairing by checking the device list in the app.</p>
            </Section>
            <Section id="EHR" title="EHR Integration Setup" date="December 23, 2013">
              <YouTubeEmbed src="https://www.youtube.com/embed/seK15PV98KQ" />
              <p>Welcome back! My name is Dorizabelle from SmartViewMD. This video will guide you through the Electronic Health Record integration setup for SmartViewMD. We'll show you how data from devices syncs with your provider's portal securely.</p>
            </Section>
            <Section id="Notifications" title="SmartViewMD Notifications" date="December 14, 2013">
              <YouTubeEmbed src="https://www.youtube.com/embed/R2HugJC2WT8" />
              <p>Hi, my name is Dorizabelle, and in this video I will explain the notification system of SmartViewMD. Learn how to customize alerts for medication, device readings, and appointment reminders all within your app dashboard.</p>
            </Section>
            <Section id="IOSDevices" title="How to set up SmartViewMD Application [IOS Devices]" date="December 14, 2013">
              <YouTubeEmbed src="https://www.youtube.com/embed/A4cGgfXqKfM" />
              <p>Hello, my name is Dorizabelle and this video tutorial will show you how to set up your SmartViewMD application on your iOS device. We'll cover downloading, logging in, pairing devices, and more.</p>
            </Section>
          </LeftColumn>

          <RightColumn>
            <div className="sticky top-24 space-y-8">
              <div>
                <h4 className="text-lg font-semibold mb-2">Archives</h4>
                <ul className="list-disc list-inside text-sm text-gray-700">
                  <li><a href="#BP" className="hover:underline">Blood Pressure Monitor</a></li>
                  <li><a href="#ANDROID" className="hover:underline">[Pair] & [Read][ANDROID]</a></li>
                  <li><a href="#iOS" className="hover:underline">[Pair] & [Read][iOS]</a></li>
                  <li><a href="#EHR" className="hover:underline">EHR Integration Setup</a></li>
                  <li><a href="#Notifications" className="hover:underline">Notifications</a></li>
                  <li><a href="#IOSDevices" className="hover:underline">iOS Setup</a></li>
                </ul>
              </div>
              <div>
                <h4 className="text-lg font-semibold mb-2">Elsewhere</h4>
                <ul className="list-disc list-inside text-sm text-gray-700">
                  <li><a href="https://github.com/SmartViewMD" className="hover:underline">GitHub</a></li>
                  <li><a href="https://www.youtube.com/channel/UC-0gPjCU7BEtAUkQwoYlx6w" className="hover:underline">YouTube</a></li>
                  <li><a href="https://vimeo.com/user138761855" className="hover:underline">Vimeo</a></li>
                </ul>
              </div>
            </div>
          </RightColumn>
        </TwoColumn>
      </Container>
      </section>

      <Footer />
    </AnimationRevealPage>
  );
}

function Section({ id, title, date, children }) {
  const Heading = tw.h1`font-black text-3xl md:text-5xl leading-snug max-w-3xl`;
  return (
    
    <section id={id} className="prose prose-primary max-w-none bg-white p-6 rounded-2l shadow-md mb-12">
      <Heading><h1>{title}</h1></Heading>
      <p className="text-sm text-gray-500">{date} by <a href="/" className="text-blue-600 hover:underline">Belle IT</a></p>
      {children}
      <br></br>
      <br></br>
      <br></br>
    </section>
    
  );
}

function YouTubeEmbed({ src }) {
  return (
    <div className="aspect-w-16 aspect-h-9 mb-4">
      <iframe
        className="w-full h-full rounded-xl shadow-md"
        src={src}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  );
}
